export default __webpack_public_path__ + "static/media/logo-long.fb9e2d96.png";